module.exports = __webpack_public_path__ + "static/PostureWork-7ab9abf53c7c132be2112033b846e77c.jpg";